import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { InvitationScreen } from './pages/InvitationScreen';
import { ProposalSubmissionScreen } from './pages/ProposalSubmissionScreen';
import { DataVerificationScreen } from './pages/DataVerificationScreen';
import { NegotiationScreen } from './pages/NegotiationScreen';
import { NegotiationProvider } from './context/NegotiationContext';
export function App() {
  return <NegotiationProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <div className="w-full min-h-screen bg-[#f5f6f8]" data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/" element={<InvitationScreen data-id="element-5" />} data-id="element-4" />
            <Route path="/submit-proposal" element={<ProposalSubmissionScreen data-id="element-7" />} data-id="element-6" />
            <Route path="/verify-data" element={<DataVerificationScreen data-id="element-9" />} data-id="element-8" />
            <Route path="/negotiation" element={<NegotiationScreen data-id="element-11" />} data-id="element-10" />
          </Routes>
        </div>
      </BrowserRouter>
    </NegotiationProvider>;
}